import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Foerderprogramm = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <g fill="none" fillRule="evenodd">
      <circle fill="#FFA86A" cx="24" cy="24" r="24" />
      <path
        d="M25 30.5c-2.51 0-4.68-1.42-5.76-3.5H25v-2h-6.42c-.05-.33-.08-.66-.08-1 0-.34.03-.67.08-1H25v-2h-5.76c1.08-2.08 3.26-3.5 5.76-3.5 1.61 0 3.09.59 4.23 1.57L31 17.3c-1.59-1.43-3.7-2.3-6-2.3-3.92 0-7.24 2.51-8.48 6H13v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H13v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </SvgIcon>
);

export default Foerderprogramm;
